import { Field, RuleControllableField, ShowRuleControllableField } from 'types/domain'

export function getJumpRule(field: Field) {
  return (field as RuleControllableField)?.jumpRule
}

export function getShowRules(field: Field) {
  return (field as ShowRuleControllableField)?.showRules
}
